import React from "react";
import {Box, ButtonLink, Stack} from "@unibuddy/patron";
import styled from "styled-components";
import useAnalytics from "shared/AnalyticsNew/hooks/useAnalytics";
import {sharedEvents} from "shared/AnalyticsNew/constants/productSpecification";

import {
    RecommendationResourceTypeEnum,
    SMALL_SCREEN_WIDTH,
    useSaveVisitedRecommendationMutation,
} from "../NextBestActions";
import {useUniversity} from "../../UniversityProvider/UniversityProvider";
import ContentTypeChip from "./NextBestActionsChip";
import useUniversityColor from "../../UniversityProvider/hooks/useUniversityColor";

const TextContainer = styled(Box)`
    height: 110px;
    @media (max-width: ${SMALL_SCREEN_WIDTH}) {
        height: 92px;
    }
`;

const CardHeading = styled(Box)`
    font-size: 16px;
    font-weight: 600;
    line-height: 25px;
    overflow: hidden;
    word-break: break-word;
    overflow-wrap: break-word;
    margin-bottom: 6px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;

const CardDescription = styled(Box)`
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    overflow: hidden;
    word-break: break-word;
    overflow-wrap: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    @media (max-width: ${SMALL_SCREEN_WIDTH}) {
        -webkit-line-clamp: 2;
    }
`;

const StyledButtonLink = styled(ButtonLink)<{buttonColor: string}>`
    color: white;
    background-color: ${(props) => props.buttonColor ?? "#0171E0"};
    &:hover:not([disabled]) {
        color: white;
        background-color: ${(props) => props.buttonColor ?? "#0171E0"};
        opacity: 0.85;
    }
`;

export default function NextBestActionsCard({
    contentId,
    batchId,
    title,
    description,
    contentType,
    url,
}: {
    contentId: string;
    batchId: string;
    title: string;
    description: string;
    contentType: RecommendationResourceTypeEnum;
    url: string;
}) {
    const {trackEvent} = useAnalytics();
    const {id: universityId} = useUniversity();
    const color = useUniversityColor();

    const [saveVisitedRecommendation] = useSaveVisitedRecommendationMutation({
        variables: {
            contentId,
            batchId,
        },
    });

    const onClick = async () => {
        await saveVisitedRecommendation();
        trackEvent(sharedEvents.nextBestActionsContentOpened.name, {
            universityId,
            contentId,
            contentType,
        });
    };
    return (
        <Stack space="small">
            <ContentTypeChip contentType={contentType} />
            <TextContainer>
                <CardHeading>{title}</CardHeading>
                <CardDescription>{description}</CardDescription>
            </TextContainer>
            <StyledButtonLink
                block
                to={url}
                external
                target="_blank"
                rel="noopener noreferrer"
                onClick={onClick}
                buttonColor={color}
            >
                Check it out
            </StyledButtonLink>
        </Stack>
    );
}
